<template>
  <!--<div>-->
  <div class="partnersMain">
    <!--banner+导航-->
    <div class="bannerBox">
      <img ref="homeBanner" src="../../../assets/img/aboutBanner.jpg" />
      <div class="topTextBox">
        <!--导航-->
        <top-nav></top-nav>
        <!--<top-nav :nav-index1="6"></top-nav>-->

        <div class="aboutBannerText animated" :class="mm4 ? 'fadeInUp' : 'hideBox'">
          <div class="title">关于我们</div>
          <div class="contentText">
            <p>Supay Technology Pty Ltd成立于2013年，总部位于澳大利亚悉尼。目前业务覆盖悉尼、墨尔本、堪培拉、布里斯班、黄金海岸、阿德莱德、霍巴特等澳洲主要城市，并正在全面开拓新西兰和英国市场。</p>
            <br>
            <p>
              我们致力于为商户和机构提供安全、便捷的多平台跨境聚合支付解方案。同时，Supay也将和合作伙伴⼀起，在本地和跨境结算、资⾦需求⽅⾯为
              商家提供更好的服务。
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="aboutContent">
      <div class="about01" id="m1" :style="contentH">
        <div class="leftBox">
          <img src="../../../assets/icon/aboutImg1.png" ref="imgH" />
        </div>
        <div class="rightBox animated" :class="mm1 ? 'fadeInRight' : 'hideBox'">
          <div class="textBox">
            <div class="titleText">关于我们</div>
            <div class="contentText">
              <p
                class="texts"
              >基于跨境贸易与移动支付高速发展的现状，为满足各企业商家在交易环节中不断提高的收、付款需求，SuperiorPay打造了以“跨境支付、移动支付、O2O支付、多渠道查账、大数据风控、线上营销”为业务核心的“全球化支付解决方案”。为企业解决了互联网交易中"支付转化率低、手续费杂乱、存在交易风险"等问题，极大提升了货币处理效率，助推了互联网交易产业的进一步完善。</p>
            </div>
          </div>
        </div>
        <div style="clear: both;"></div>
      </div>

      <div class="about02" id="m2" :style="contentH">
        <div class="rightBox">
          <div class="textBox animated" :class="mm2 ? 'fadeInLeft' : 'hideBox'">
            <div class="titleText">支付产品</div>
            <div class="contentText">
              <p
                class="texts"
              >SuperiorPay是支付宝在澳洲首家官方授权合作机构。目前已覆盖支付宝支付、微信支付等主流移动支付方式和多样化互联网社交平台，采取手续费自动计算，一站式管理财务数据，支持Web + APP多渠道查账，后台操作便捷，统计功能强大，可根据商户需求定制集团账户，掌握分店营业动态。</p>
            </div>
          </div>
        </div>
        <div class="leftBox">
          <img src="../../../assets/icon/aboutImg2.png" />
        </div>
        <div style="clear: both;"></div>
      </div>

      <div class="about01" id="m3" :style="contentH">
        <div class="leftBox">
          <img src="../../../assets/icon/aboutImg3.png" />
        </div>
        <div class="rightBox animated" :class="mm3 ? 'fadeInRight' : 'hideBox'">
          <div class="textBox">
            <div class="titleText">资金安全</div>
            <div class="contentText">
              <p
                class="texts"
              >在安全性能方面，公司是澳洲金融牌照授权方，资金由澳大利亚银行管理，与微信、支付宝官方合作，采取AML、AF等多重风控管制。基础设施金融级加密，数据传输和存储均采用加密算法，资金到账快速，安全有保障。</p>
            </div>
          </div>
        </div>
        <div style="clear: both;"></div>
      </div>
    </div>

    <!--底部-->
    <Footer></Footer>
  </div>
  <!--</div>-->
</template>

<script>
import topNav from "./navCn";
import Footer from "@/components/Footer"
let timer = null; //定义初始值
export default {
  name: "aboutUsCn",
  components: { topNav,Footer },
  props: {
    step: {
      //此数据是控制动画快慢的
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      mm1: false,
      mm2: false,
      mm3: false,
      mm4: false,
      contentH: {
        height: ""
      }
    };
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll); //监听页面滚动事件
  },
  mounted() {
    document.documentElement.scrollTop = 0;

    console.log("aa", this.$refs.imgH.offsetHeight);
    if (this.$refs.imgH.offsetHeight === 0) {
      if (window.innerWidth > 1600) {
        this.contentH.height = "880px";
      } else {
        this.contentH.height = "630px";
      }
    } else {
      this.contentH.height = this.$refs.imgH.offsetHeight - 10 + "px";
    }

    this.mm4 = true;
    // console.log(window.innerWidth)
    if (window.innerWidth > 1366) {
      window.addEventListener("scroll", this.handleScroll);
    } else {
      this.mm1 = true;
      this.mm2 = true;
      this.mm3 = true;
    }
  },
  methods: {
     //  点击导航
      navClick(url){
        this.$router.push(url);
      },
    toTop() {
      // 动画

      timer = setInterval(function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        // this.isTop = true
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },

    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      var offsetTop1 = document.querySelector("#m1").offsetTop;
      var offsetTop2 = document.querySelector("#m2").offsetTop;
      var offsetTop3 = document.querySelector("#m3").offsetTop;

      if (scrollTop > offsetTop1 - 600) {
        this.mm1 = true;
      } else {
        this.mm1 = false;
      }
      if (scrollTop > offsetTop2 - 600) {
        this.mm2 = true;
      } else {
        this.mm2 = false;
      }
      if (scrollTop > offsetTop3 - 600) {
        this.mm3 = true;
      } else {
        this.mm3 = false;
      }
    }
  }
};
</script>

<style scoped>
.aboutBannerText {
  width: 25%;
  float: right;
  padding-right: 25%;
  min-width: 460px;
  margin-top: 15%;
}
.aboutBannerText .title {
  font-size: 1.5rem;
  font-family: PingFangRegular;
  font-weight: 600;
  color: #fff;
  width: 100%;
  line-height: 6rem;
}
.aboutBannerText .contentText {
  width: 100%;
  height: auto;
}
.aboutBannerText .contentText > p {
  width: 100%;
  height: calc(100% - 10rem);
  font-family: PingFangRegular;
  font-weight: 500;
  font-size: 0.875rem;
  color: #fff;
  line-height: 1.8rem;
}

.partnersMain {
  width: 100%;
  height: auto;
}
.partnersMain .bannerBox {
  width: 100%;
  height: auto;
  position: relative;
}
.partnersMain .bannerBox > img {
  width: 100%;
}
.partnersMain .bannerBox .topTextBox {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

/*内容部分*/
.aboutContent {
  width: 100%;
  height: auto;
  padding: 0rem;
  background-color: #fff;
  margin-top: -3px;
  overflow: hidden;
}

/*模块1*/
/*height: 56.25rem;*/
.about01 {
  width: 100%;
  height: auto;
  background-color: #fff;
  margin-top: -3px;
  position: relative;
}
.about01 .leftBox {
  width: 50%;
  height: 100%;
  float: left;
}
.about01 .leftBox > img {
  width: 100%;
  height: 100%;
}
.about01 .rightBox {
  width: 50%;
  height: 100%;
  float: right;
  position: relative;
}
.about01 .rightBox .textBox {
  width: 48%;
  height: 23.6rem;
  padding: 3rem 4rem;
  position: absolute;
  left: -10%;
  top: 22%;
  background-color: #fff;
  box-shadow: 0 0 30px 0px rgba(0, 0, 0, 0.2);
}
.about01 .rightBox .textBox .titleText {
  font-size: 1.5rem;
  font-family: PingFangRegular;
  font-weight: 600;
  color: #4a4a4a;
  width: 100%;
  line-height: 4rem;
  text-align: center;
}
.about01 .rightBox .textBox .contentText {
  width: 100%;
  height: calc(100% - 10rem);
  font-family: PingFangRegular;
  font-weight: 500;
  font-size: 0.875rem;
  color: #4a4a4a;
  line-height: 1.6rem;
  text-align: center;
}
.about01 .rightBox .textBox .contentText .texts {
  margin-top: 2rem;
}

/*模块2*/
.about02 {
  width: 100%;
  height: auto;
  background-color: #fff;
  margin-top: 0px;
  position: relative;
}
.about02 .rightBox {
  width: 50%;
  height: 100%;
  position: absolute;
  left: 0;
}
.about02 .rightBox .textBox {
  width: 48%;
  height: 23.6rem;
  padding: 3rem 4rem;
  position: absolute;
  right: -10%;
  top: 22%;
  background-color: #fff;
  box-shadow: 0 0 30px 0px rgba(0, 0, 0, 0.2);
}
.about02 .rightBox .textBox .titleText {
  font-size: 1.5rem;
  font-family: PingFangRegular;
  font-weight: 600;
  color: #4a4a4a;
  width: 100%;
  line-height: 4rem;
  text-align: center;
}
.about02 .rightBox .textBox .contentText {
  width: 100%;
  height: calc(100% - 10rem);
  font-family: PingFangRegular;
  font-weight: 500;
  font-size: 0.875rem;
  color: #4a4a4a;
  line-height: 1.6rem;
  text-align: center;
}
.about02 .rightBox .textBox .contentText .texts {
  margin-top: 2rem;
}
.about02 .leftBox {
  width: 50%;
  height: 100%;
  float: right;
}
.about02 .leftBox > img {
  width: 100%;
  height: 100%;
}

.hideBox {
  display: none;
}

@media screen and (max-width: 1600px) {
  .about01 .rightBox .textBox {
    width: 70%;
    padding: 1.5rem 2rem;
    top: 17%;
  }
  .about02 .rightBox .textBox {
    width: 70%;
    padding: 1.5rem 2rem;
    top: 17%;
  }
}
.uline{
  /* height:1px; */
  margin-top: 10px;
  border-bottom: #4a4a4a 1px solid;
}
.privacy {
  /* border-top: #4a4a4a 1px solid; */
  margin-top: 10px;
}
</style>

